/** @file Whole texels a two-point cut removes from its edge: round(T (1 - ratio)) below ratio 1 (21.6). */

/** `ratio < 1 ? round(extent (1 - ratio)) : 0`, never more than `extent`. */
export function cutTexelsOf(extent: number, ratio: number): number {
  return ratio < 1 ? Math.min(extent, Math.round(extent * (1 - Math.max(0, ratio)))) : 0;
}
